import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import '@/assets/stylus/main.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
})